export default "__VITE_ASSET__DhY1YmDx__"